import React, { useEffect, useState } from 'react'
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import blobToBase64 from 'blob-to-base64'
import CreateForm from './CreateForm';
import TuneIcon from '@mui/icons-material/Tune';
import EditNoteIcon from '@mui/icons-material/EditNote';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PreviewIcon from '@mui/icons-material/Preview';
import EditForm from './editForm/EditForm';

import MenuIcon from '@mui/icons-material/Menu';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomSpinner from '../components/CustomSpinner';
function Forms({ serverURL, user, setShowSideOverlay }) {


    const [showToast, setShowToast] = useState(false)
    const [toastTitle, setToastTitle] = useState("")
    const [toastType, setToastType] = useState("")
    const [toastMessage, setToastMessage] = useState("")

    const [deletePermission, setDeletePermission] = useState(false)
    const [formToDelete, setFormToDelete] = useState(null);

    const [deleteSuccess, setDeleteSuccess] = useState(false)

    const [formSectionVisibility, setFormSectionVisibility] = useState("forms")

    const [editFormView, setEditFormView] = useState(false)

    const [editFormData, setEditFormData] = useState({ "form": [], "buttons": [] })

    const [customFormDataView, setCustomFormDataView] = useState({ "form": [], "buttons": [] })

    const [allForms, setAllForms] = useState([]);

    const [customFormView, setCustomFormView] = useState(false);
    const [allFormLogs, setAllFormLogs] = useState([])

    const [formsLoading, setFormsLoading] = useState(true);
    const [logsLoading, setLogsLoading] = useState(true);

    const getAllForms = async () => {
        setFormsLoading(true)
        const getAllForms = await axios.post(serverURL + "/forms/getAll")
        if (getAllForms.status === 200) {
            // console.log(getAllForms.data)
            if (user.userType !== "admin") {
                let filteredId = []
                if (user.assignedForms) {
                    user.assignedForms.map((ids, key) => {
                        return filteredId.push(ids.value)
                    })
                    const fiteredFormData = getAllForms.data.filter((form) => {
                        return filteredId.includes(form._id)
                    })
                    setAllForms(fiteredFormData)
                }
                else {
                    setAllForms([])
                }
                setFormsLoading(false)
            } else {
                setAllForms(getAllForms.data)
                setFormsLoading(false)
            }
        }
        else {
            console.log(getAllForms.data)
            setFormsLoading(false)
        }
    }
    const getAllLogs = async () => {
        setLogsLoading(true)
        const getNow = await axios.post(serverURL + "/formLogs/getAllLogs");
        if (getNow.status === 200) {
            setAllFormLogs(getNow.data);
            setLogsLoading(false)
        } else {
            console.log(getNow.data)
            setLogsLoading(false)
        }
    }
    useEffect(() => {
        getAllForms()
        getAllLogs()
    }, [])

    useEffect(() => {
        if (formSectionVisibility === "forms") {
            getAllForms()
            getAllLogs()
        }
    }, [formSectionVisibility])

    const fillThisForm = async (formData) => {

        let fileds = [];
        formData.fields.form.map((field, key) => {
            return fileds.push({ "name": field.label.value, "value": field.type.value === "Select" ? field.label.id : field.options[0].id })
        })

        setCustomFormView(true)
        let allData = formData.fields;

        allData["formName"] = formData.name;
        allData["formId"] = formData._id;


        console.log(allData)
        setCustomFormDataView(allData);

    }

    const saveCustomData = async (e, allRequiredData) => {
        e.preventDefault();

        const button = document.getElementById("saveFormDataBTN");

        button.innerHTML = `<div class="spinner-border-sm spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>`;
        button.disabled = true

        let dataToSave = {};

        await Promise.all(
            allRequiredData.form.map(async (data, key) => {

                if (data.type.value === "Select") {
                    const valueOf = document.getElementById(data.label.id + "_view")
                    return dataToSave[`${data.label.value}`] = valueOf.value
                } else if (data.type.value === "File") {
                    const valueOf = document.getElementById(data.options[0].id + "_view")

                    let fileArray = [];
                    for (let j = 0; j < valueOf.files.length; j++) {
                        const toBase64 = (file) =>
                            new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = (error) => reject(error);
                            });

                        const base64File = await toBase64(valueOf.files[j]);

                        // Create payload
                        const payload = {
                            data: base64File.split(',')[1], // Exclude "data:<type>;base64,"
                            fileName: valueOf.files[j].name,
                            fileType: valueOf.files[j].type,
                        };

                        fileArray.push(payload)
                    }
                    return dataToSave[`${data.label.value}`] = fileArray

                } else {
                    const valueOf = document.getElementById(data.options[0].id + "_view")
                    return dataToSave[`${data.label.value}`] = valueOf.value
                }
            })
        )


        // console.log(dataToSave)


        const sendData = await axios.post(serverURL + "/forms/saveFormData", {
            "formRefId": allRequiredData.formId,
            "updatedBy": user.email,
            "logs": [],
            "submittedData": dataToSave
        })

        if (sendData.status === 200) {

            e.target.reset()

            button.innerHTML = `Submit`;
            button.disabled = false

            setShowToast(true)
            setToastTitle("Saved")
            setToastType("success")
            setToastMessage("Saved Successfully")

            // setTimeout(() => {
            //     setCustomFormView(false)
            // }, 3000)

        } else {
            button.innerHTML = `Submit`;
            button.disabled = false

            setShowToast(true)
            setToastTitle("Error")
            setToastType("error")
            setToastMessage(sendData.data)
        }



    }

    const editThisForm = (form) => {
        setEditFormView(true)
        setEditFormData(form)
    }


    const deleteThisFormNow = async (formData, btn) => {
        const button = btn.target
        button.innerHTML = `<div class="spinner-border-sm spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>`;
        button.disabled = true


        const query =
        {
            "id": formData._id,
            "userRef": user._id,
            "userId": user.email,
            "userName": user.name,
            "name": formData.name
        }
        const deleteNow = await axios.post(serverURL + "/forms/deleteForm", query);
        if (deleteNow.status === 200) {
            button.innerHTML = `Delete`;
            button.disabled = false

            setToastMessage("Form Deleted Successfully");
            setToastTitle("Success")
            setToastType("success")
            setShowToast(true)
            setDeleteSuccess(true)
            getAllForms()
            getAllLogs()
        } else {
            console.log(deleteNow.data)

            button.innerHTML = `Delete`;
            button.disabled = false

            setToastMessage(deleteNow.data)
            setToastTitle("Error")
            setToastType("error")
            setShowToast(true)
        }
    }

    return (
        <>
            <div className="transback h-100 d-flex flex-column p-3">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Forms</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="forms"
                    id="uncontrolled-tab-example"
                    className="pt-3 px-3 sticky-top"
                    // fill
                    activeKey={formSectionVisibility}
                    onSelect={(k) => { setFormSectionVisibility(k); }}
                >
                    <Tab eventKey="forms" title="Forms" className={`p-0 ${formSectionVisibility === "forms" ? "h-100" : ""}`}>
                        {
                            formSectionVisibility === "forms" && editFormView === false ?
                                !formsLoading ?
                                    <div className="container-fluid h-100 overflow-auto p-3">
                                        <div className="row">
                                            {
                                                allForms ?
                                                    allForms.length > 0 ?
                                                        allForms.map((form, key) => {
                                                            return (
                                                                <div className="col-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3 mb-4" key={key} onClick={() => { fillThisForm(form) }}>
                                                                    <div className="card shadow-sm w-100 h-100 overflow-hidden" style={{ cursor: "pointer" }} title={`${"Name"}: ${form.name}\nCreated At: ${new Date(form.createdAt).toDateString() + ", " + new Date(form.createdAt).toLocaleTimeString()}`}>
                                                                        <div className="card-header d-flex justify-content-between align-items-center gap-3">
                                                                            <span>{form.name}</span>
                                                                            {
                                                                                user.userType === "admin" ?
                                                                                    <div className='d-flex gap-3'>
                                                                                        <button className='btn p-0' onClick={(e) => { e.stopPropagation(); editThisForm(form); }}>
                                                                                            <EditNoteIcon />
                                                                                        </button>
                                                                                        <button className='btn p-0' onClick={(e) => { e.stopPropagation(); setDeletePermission(true); setFormToDelete(form); }}>
                                                                                            <DeleteIcon />
                                                                                        </button>
                                                                                    </div>
                                                                                    :
                                                                                    ""
                                                                            }
                                                                        </div>
                                                                        <div className="card-body bg-info d-flex align-items-start flex-column" style={{ fontSize: ".8rem" }}>
                                                                            {
                                                                                form.logs ?
                                                                                    form.logs.length > 0 ?
                                                                                        <>
                                                                                            <span>
                                                                                                Updated By: {form.logs[form.logs.length - 1]["filledBy"]}
                                                                                            </span>
                                                                                            <span>
                                                                                                Last Entry: {dayjs(form.updatedAt).format("DD MMM YYYY")}
                                                                                            </span>
                                                                                        </>
                                                                                        :
                                                                                        ""
                                                                                    :
                                                                                    ""
                                                                            }

                                                                        </div>
                                                                        <div className="card-footer" style={{ fontSize: ".8rem" }}>
                                                                            <p className='p-0 m-0 text-secondary'>Created At: {dayjs(form.createdAt).format("DD MMM YYYY")}</p>
                                                                        </div>
                                                                    </div>
                                                                </div >
                                                            )
                                                        })
                                                        :
                                                        <div className="glassInfo text-center rounded-0">
                                                            No Form Available
                                                        </div>
                                                    :
                                                    <div className="glassInfo text-center rounded-0">
                                                        No Form Available
                                                    </div>
                                            }
                                        </div >
                                    </div >
                                    :
                                    <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-2'>
                                        <CustomSpinner size={1}/>
                                        <span className='text-light fs-6'>Loading Froms</span>
                                    </div>
                                :
                                formSectionVisibility === "forms" && editFormView ?
                                    <div className='w-100 pb-5 pt-3 d-flex justify-content-center'>
                                        <EditForm oldData={editFormData} user={user} serverURL={serverURL} setFormSectionVisibility={setFormSectionVisibility} setEditFormView={setEditFormView} getAllForms={getAllForms} />
                                    </div>
                                    :
                                    ""
                        }
                    </Tab >
                    {
                        user.userType === "admin" ?
                            <Tab eventKey="newForm" title="New Form" className={`d-flex justify-content-center`}>
                                {
                                    formSectionVisibility === "newForm" ?
                                        <div className='w-100 pb-5 pt-3 d-flex justify-content-center'>
                                            <CreateForm serverURL={serverURL} user={user} setFormSectionVisibility={setFormSectionVisibility} />
                                        </div>
                                        :
                                        ""
                                }
                            </Tab>
                            :
                            ""
                    }
                    < Tab eventKey="formLogs" title="Logs" className={`p-0 ${formSectionVisibility === "formLogs" ? "h-100" : ""}`} >
                        {
                            formSectionVisibility === "formLogs" ?
                                !logsLoading ?
                                    <div className='w-100 d-flex flex-column gap-1 p-3'>
                                        <div className='d-flex flex-column align-items-center'>
                                            {
                                                allFormLogs.length > 0 ?
                                                    allFormLogs.map((log, key) => {
                                                        return (
                                                            <div key={key} className={`w-100 p-2 mb-1 rounded-0 overflow-hidden text-break alert ${log.eventType === "Deleted" ? "alert-danger" : "alert-success"}`}>
                                                                <div className='fw-bold'>Form {log.eventType}</div>
                                                                <hr className='my-1' />
                                                                <table cellPadding={3} className=''>
                                                                    <tbody>
                                                                        <tr valign="middle">
                                                                            <td align='center'><i className='fa fa-user'></i></td>
                                                                            <td>{log.useremail}</td>
                                                                        </tr>
                                                                        <tr valign="middle">
                                                                            <td align='center'><i className='fa fa-file'></i></td>
                                                                            <td>{log.data[0].formName}</td>
                                                                        </tr>
                                                                        <tr valign="middle">
                                                                            <td align='center'><i className='fa fa-clock'></i></td>
                                                                            <td>{dayjs(log.createdAt).format("DD MMM YYYY, hh:mma")}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    <div className="glassInfo w-100 text-center">No Logs</div>
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-2'>
                                        <CustomSpinner/>
                                        <span className='text-light fs-6'>Loading Logs</span>
                                    </div>
                                :
                                ""
                        }
                    </Tab >
                </Tabs >
            </div >

            <Modal
                show={customFormView}
                size='md'
                backdrop="static"
                onHide={() => {
                    setCustomFormView(false);
                    setShowToast(false);
                    setToastTitle("");
                    setToastType("");
                    setToastMessage("");
                }}
                centered
            >
                <form onSubmit={(e) => { saveCustomData(e, customFormDataView) }} className='p-3 shadow-sm border rounded bg-light d-flex flex-column gap-2'>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span className='themeTextColor'>
                                {customFormDataView.formName}
                            </span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='d-flex flex-column gap-2'>
                        {
                            customFormDataView.form.map((data, key) => {
                                return (
                                    <div key={key} className='p-0'>
                                        <label htmlFor={`${data.type.value === "Select" ? data.label.id : data.options[0].id}_view`} className='w-100'>
                                            {
                                                data.type.value !== "Reset" && data.type.value !== "Submit" ?
                                                    <>
                                                        {data.label.value + (JSON.parse(data.isRequired.value) ? " *" : "")}

                                                        {
                                                            JSON.parse(data.isDistinct.value) ? <span style={{ color: "red" }}>*</span>
                                                                :
                                                                ""
                                                        }
                                                    </>
                                                    :
                                                    ""
                                            }
                                            {/* {JSON.stringify(data.type)} */}
                                            {
                                                data.type.value === "Text" ?
                                                    <input type='text' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                    :
                                                    data.type.value === "Phone" ?
                                                        <input type='tel' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                        :
                                                        data.type.value === "Number" ?
                                                            <input type='number' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                            :
                                                            data.type.value === "Email" ?
                                                                <input type='email' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                :
                                                                data.type.value === "Select" ?
                                                                    <select id={`${data.label.id}_view`} required={JSON.parse(data.isRequired.value)} className='form-control'>
                                                                        {
                                                                            data.options.map((option, key) => {
                                                                                return (
                                                                                    <option key={key} value={option.value} id={`${option.id}_view`}>{option.value}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                    :
                                                                    data.type.value === "Date" ?
                                                                        <input type='date' id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                        :
                                                                        data.type.value === "Textarea" ?
                                                                            <textarea id={`${data.options[0].id}_view`} value={data.options.value} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                            :
                                                                            data.type.value === "File" ?
                                                                                <input type='file' multiple id={`${data.options[0].id}_view`} required={JSON.parse(data.isRequired.value)} className='form-control' />
                                                                                :
                                                                                data.type.value === "Reset" ?
                                                                                    <button type="reset" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-secondary rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                    :
                                                                                    data.type.value === "Submit" ?
                                                                                        <button type="button" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                        :
                                                                                        "Undefined Type"
                                            }
                                        </label>
                                    </div>
                                )
                            })
                        }

                        {
                            showToast ?
                                <div className={`alert alert-${toastType === "error" ? "danger" : "success"} p-0 w-100 text-center mt-3`}>
                                    {toastMessage}
                                </div>
                                :
                                ""
                        }

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='w-100'>
                            {
                                customFormDataView.buttons.length > 0 ?
                                    <div className='d-flex gap-2 justify-content-center align-items-center'>
                                        {
                                            customFormDataView.buttons.map((data, key) => {
                                                return (
                                                    data.type.value === "Reset" ?
                                                        <button key={key} type="reset" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-secondary rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value ? data.label.value : "Reset"}</button>
                                                        :
                                                        data.type.value === "Submit" ?
                                                            <button key={key} type="submit" id={`${data.type.id}_view saveFormDataBTN`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value ? data.label.value : "Submit"}</button>
                                                            :
                                                            "Undefined Type"
                                                )
                                            })
                                        }
                                    </div>
                                    :
                                    <div className='d-flex gap-2 justify-content-center align-items-center'>
                                        <button type="submit" className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }} id="saveFormDataBTN">Submit</button>
                                    </div>
                            }
                        </div>
                    </Modal.Footer>
                </form>
            </Modal >


            <Modal
                show={deletePermission}
                size='md'
                backdrop="static"
                onHide={() => { setDeletePermission(false); setFormToDelete(null); setDeleteSuccess(false); setShowToast(false); setToastMessage(""); setToastType(""); setToastTitle(""); }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            Delete Form
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='d-flex flex-column gap-2'>
                    {
                        formToDelete ?
                            <>
                                <p className='text-center fs-5'>Do you really want to delete this form?</p>
                                <p className='text-center fw-bold'>{formToDelete.name}</p>
                            </>
                            :
                            ""
                    }
                    {
                        showToast &&
                        <div className={`alert alert-${toastType === "error" ? "danger" : "success"} p-0 w-100 text-center mt-3`}>
                            {toastMessage}
                        </div>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex gap-3 justify-content-center align-items-center w-100'>
                        <button className='btn btn-sm btn-secondary w-100 rounded-pill' style={{ maxWidth: "120px" }} onClick={(() => { setDeletePermission(false); setFormToDelete(null); setDeleteSuccess(false); setShowToast(false); setToastMessage(""); setToastType(""); setToastTitle(""); })}>
                            {
                                !deleteSuccess ? "Cancel" : "Close"
                            }
                        </button>
                        {
                            !deleteSuccess ?
                                <button className='btn btn-sm btn-danger w-100 rounded-pill' style={{ maxWidth: "120px" }} onClick={(e) => { deleteThisFormNow(formToDelete, e); }}>Delete</button>
                                :
                                ""
                        }
                    </div>
                </Modal.Footer>
            </Modal >
        </>
    )
}

export default Forms